import { DestroyRef, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { distinctUntilChanged, Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { environment } from "../../../environments/environment";
import { selectCurrentUser, selectToken } from '../stores/user/user.selectors';
import { RootState } from '../stores/store';
import { User } from '../../shared/interfaces/user.interfaces';

// Este interceptor captura todos los httpRequests que se hacen hacia la api de Beat y les agrega el Bearer token y el dealer del usuario logueado

@Injectable()

export class httpInterceptor implements HttpInterceptor {

  private currentUser?: User;
  private token?: string;

  constructor(
    private store: Store<RootState>,
    private destroyRef: DestroyRef
  ) {
    this.store.select(selectCurrentUser).pipe(
      distinctUntilChanged((a, b) => a?.token === b?.token && a?.dealer?.id === b?.dealer?.id),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((user) => {
      this.currentUser = user;
    });
    this.store.select(selectToken).pipe(
      distinctUntilChanged(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((token) => {
      this.token = token;
    });
  }

  intercept(req: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {

    // Si la solicitud es para assets, no la toques
    if (req.url.includes('/assets/')) {
      return handler.handle(req);
    }

    let authReq = req.clone({ url: environment.apiUrl + req.url });

    if (!this.currentUser?.token) {
      if (!this.token) {
        return handler.handle(authReq)
      } else {
        authReq = authReq.clone({
          setHeaders: {
            Authorization: `Bearer ${this.token}`,
          }
        });
        return handler.handle(authReq)
      }
    } else {
      authReq = authReq.clone({
        setHeaders: {
          Authorization: `Bearer ${this.currentUser.token}`,
          Dealer: JSON.stringify(this.currentUser.dealer)
        }
      });
      return handler.handle(authReq)
    }
  }
}
